import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-six-two-seven',
  templateUrl: './two-six-two-seven.component.html',
  styleUrls: ['./two-six-two-seven.component.scss']
})
export class TwoSixTwoSevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
